import { forwardRef, Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AbstractFilterValuesLoadGuard } from 'app/core/guards/abstract-filter-values-load.guard';
import { OrdersSandbox } from 'app/core/sandboxes/orders.sandbox';
import { FilterValues } from 'app/core/interfaces/filtervalues.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { RootState } from '../store';

@Injectable({ providedIn: 'root' })
export class OrderFilterValuesLoadGuard extends AbstractFilterValuesLoadGuard {
  private sandbox: OrdersSandbox;

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => OrdersSandbox)) sandbox) {
    super('OrdersFilterValuesLoadGuard', store, (state: RootState) => state.orders.filterValues);
    this.sandbox = sandbox;
  }

  loader(t: any, params: { [p: string]: string }): void {
    this.sandbox.loadOrdersFilterValues();
    this.sandbox.setActiveCustomerOnCopyReload();
  }

  resetter(params: { [p: string]: string }): void {
    this.sandbox.resetOrdersFilterValues();
  }

  getDependencyRouteData() {
    return {
      authorization: 'ORDER.QUERY',
    };
  }
}
